// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IVOWx","open":"styles_open__x4Pxz"};